/*
 * @Author: wlo_o
 * @Date: 2022-02-16 09:13:05
 * @LastEditors: wlo_o
 * @LastEditTime: 2022-02-17 15:16:43
 * @FilePath: /frontend/lib/mixins/RouterMixin.js
 * @Description: 路由跳转相关逻辑
 *
 * Copyright (c) 2022 by 青岛百洋智能科技股份有限公司, All Rights Reserved.
 */
import pick from 'lodash/pick'

export default {
  methods: {
    /**
     * 添加一条历史记录
     * @param {*} cfg 组件配置
     * @param {*} clearHistory 清空历史记录
     */
    pushHistory (cfg, clearHistory = false) {
      this.$OecpMetaDataEventBus.history = [
        ...(clearHistory ? [] : (this.$OecpMetaDataEventBus.history || [])),
        JSON.parse(JSON.stringify(pick(cfg, ['componentName', 'attrs'])))]
    },
    /**
     * 后退
     */
    goBack () {
      let { history } = this.$OecpMetaDataEventBus
      if (history && history.length) {
        let { componentName, attrs } = history.pop()
        this.$OecpMetaDataEventBus.component.componentName = componentName
        this.$OecpMetaDataEventBus.component.attrs = attrs
      }
    },
    /**
     * 跳转
     * @param {*} cfg 跳转参数 componentName、attrs 必须，history非必须
     * @param {*} historyPush 是否添加历史记录
     * @param {*} clearHistory 清空历史记录
     */
    goto (cfg, historyPush = false, clearHistory = false) {
      let { componentName, attrs, history } = cfg
      historyPush && this.pushHistory(history || this.$OecpMetaDataEventBus.component, clearHistory)
      this.$OecpMetaDataEventBus.component.componentName = componentName
      this.$OecpMetaDataEventBus.component.attrs = attrs
    }
  }
}
